/**
 * Editorial intro block — an elevated replacement for plain grey intro paragraphs.
 *
 * Renders the copy in Bodoni Moda (font-display) with a small ornamental divider
 * beneath. Wrap key phrases in <em>…</em> to get italic blush (brand-pink) accents.
 *
 * Usage:
 *   <SectionIntro>
 *     Every flavour is <em>hand-crafted</em> in our Sydney studio.
 *   </SectionIntro>
 */
export default function SectionIntro({ children, className = "" }) {
    return (
        <div className={`text-center max-w-3xl mx-auto ${className}`}>
            <p className="font-display text-ink leading-[1.5] text-xl md:text-2xl lg:text-[1.65rem] [&_em]:italic [&_em]:text-blush [&_em]:font-normal">
                {children}
            </p>
            <div className="mt-6 flex items-center justify-center gap-3" aria-hidden="true">
                <span className="h-px w-10 bg-blush/40" />
                <span className="w-1.5 h-1.5 rounded-full bg-blush" />
                <span className="h-px w-10 bg-blush/40" />
            </div>
        </div>
    );
}
